// A simple mixin for calling the __() function for JavaScript translations

export const localizationMixin = {
  methods: {
    __: window.__,
    _n: window._n
  }
}

export default localizationMixin;
